import { UserInformation, getUserInformation } from "@/api/signin";
import { QueryOptionsWithoutKeyAndFn } from "@/types/types";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { userKeys } from "./keys";

export function getUserInformationOptions(
	options?: QueryOptionsWithoutKeyAndFn<UserInformation>,
) {
	return queryOptions({
		queryFn: getUserInformation,
		queryKey: userKeys.userInformation(),
		...options,
	});
}

export default function useGetUserInformation(
	options?: QueryOptionsWithoutKeyAndFn<UserInformation>,
) {
	return useQuery(getUserInformationOptions(options));
}
